import { Box, Button, Grid, Typography } from "@material-ui/core";
import { getTranslation } from "../../../../heplers/translationHelper";
import { AreaList } from "../../../common/tablePlacement/AreaList";
import TableCanvas from "../../../common/tablePlacement/TableCanvas"
import { useEffect, useState } from "react";
import { Get, Post } from "../../../../actions";
import { MyDialog } from "../../../../components/Dialog";
import ButtonWithLoading from "../../../../components/ButtonWithLoading";

export const ConfirmReservationDialog=({dayTime,selectedTables,setSelectedTables,selectedReservation,onConfirmReservation,sideContent,isMerging:isMergingProp,setIsMerging:setIsMergingProp})=>{
      const [areas, setAreas] = useState([]);
      const [isMergingState, setIsMergingState] = useState(false);
      // the parent may own the merge state (and show the merge button itself, e.g. in the dialog header)
      const mergeControlled = isMergingProp !== undefined && !!setIsMergingProp;
      const isMerging = mergeControlled ? isMergingProp : isMergingState;
      const setIsMerging = mergeControlled ? setIsMergingProp : setIsMergingState;
            const [selectedArea, setSelectedArea] = useState(null);
            // const [selectedTable, setSelectedTable] = useState(null);
            // const [selectedForMerge, setSelectedForMerge] = useState([]);
            
      

        useEffect(()=>{
          if(selectedReservation)
            fetchAreas();
        },[selectedReservation])

        const fetchAreas = async () => {
          try {
            await Get(
              {},
              "TableManagement/GetAllAreas",
              null,
              (response) => {
                setAreas(response.data);
                if(response.data.length>0 ){
                  setSelectedArea(response.data.find(x=>x.id==selectedReservation?.areaId))

                }
                // const initialTables = {};
                // response.data.forEach((area) => {
                //   initialTables[area.id] = [];
                // });
                // setTables(initialTables);
              },
              (error) => {
                console.error("Error fetching areas:", error);
              }
            );
          } catch (error) {
            console.error("Error fetching areas:", error);
          }
        };
    
       


    return (
      <Box>
        <Grid container >
          <Grid >
            <AreaList
              areas={areas}
              onAreaChange={(newArea) => {
                setSelectedArea(newArea);
                // onAreaSelected(newArea);
              }}
              selectedArea={selectedArea?selectedArea:areas.find(x=>x.id==selectedReservation?.areaId)}
            />
            {/* merge button next to the rooms (it used to be at the far right of the plan, off screen) */}
            <Box mt={2} style={{ width: "300px" }}>
              {!mergeControlled && (
                <Button
                  variant="contained"
                  color={isMerging ? "secondary" : "primary"}
                  fullWidth
                  onClick={() => {
                    // merging adds tables to the ones already chosen (click a chosen table to remove it)
                    setIsMerging(!isMerging);
                  }}
                >
                  {isMerging
                    ? getTranslation("Finish merging", "Terminer la fusion", "Zusammenlegen beenden")
                    : getTranslation("Merge tables", "Fusionner des tables", "Tische zusammenlegen")}
                </Button>
              )}
              {isMerging && (
                <Typography variant="body2" style={{ color: "#B00020", marginTop: 8 }}>
                  {getTranslation(
                    "You can select multiple tables for merging",
                    "Vous pouvez sélectionner plusieurs tables à fusionner",
                    "Sie können mehrere Tische zum Zusammenlegen auswählen"
                  )}
                </Typography>
              )}
              {sideContent && <Box mt={2}>{sideContent}</Box>}
            </Box>
          </Grid>
          <Grid >
              <TableCanvas 
                dayTime={dayTime}
                selectedArea={selectedArea?selectedArea:areas.find(x=>x.id==selectedReservation?.areaId)}
                enableReservation={true}
                formdata={selectedReservation}
                // onTableSelected={(selected) => {
                //   setSelectedForMerge(selected)
                //   onConfirmReservation(selected)
                // }
                // }
                selectedForMerge={selectedTables}
                setSelectedForMerge={setSelectedTables}
                isMerging={isMerging}
                setIsMerging={setIsMerging}
              />
            </Grid>
        </Grid>
      </Box>
    );

}